const TABS = [
    { id: "overview", label: "Overview", icon: "fa-light fa-gauge-high" },
    { id: "graph", label: "Graph", icon: "fa-light fa-chart-line" },
];

export default function RectifierNav({ activeTab, onChange }) {
    return (
        <nav className="rectifier-nav">
            {TABS.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    className={`rectifier-nav__item ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => onChange(tab.id)}
                >
                    <i className={tab.icon} />
                    {tab.label}
                </button>
            ))}
        </nav>
    );
}
